import React, { useEffect, useState } from 'react';
import { superListTenants, superCrearTenant, superToggleTenant, superSetPlan, superSetModulos, superRenovarSuscripcion,
  superGetTenantDian, superSetTenantDian, superUploadTenantCert, superEnviarFacturaPrueba, superEnviarNotaPrueba, superEnviarSetCompleto, superEnviarDeposSet, superDeposEstado, superEnviarNominaSet, superSincronizarDs } from '../services/api';
import { MODULOS, MODULOS_CORE, PLANES as PLAN_DEFS } from '../config/modulos';

// Estado de suscripción de un tenant a partir de su fecha de vencimiento.
const subEstado = (t) => {
  if (!t.fecha_vencimiento) return { txt: '—', col: '#64748b', dias: null };
  const dias = Math.ceil((new Date(t.fecha_vencimiento) - new Date()) / 86400000);
  const fecha = new Date(t.fecha_vencimiento).toLocaleDateString('es-CO');
  if (dias <= 0) return { txt: `Vencida (${fecha})`, col: '#fca5a5', dias };
  if (t.es_prueba) return { txt: `Prueba · ${dias}d (${fecha})`, col: dias <= 3 ? '#fca5a5' : '#fde68a', dias };
  return { txt: `${fecha} · ${dias}d`, col: dias <= 15 ? '#fde68a' : '#86efac', dias };
};

const fmtK = (n) => {
  n = Number(n || 0);
  if (n >= 1e9) return '$' + (n / 1e9).toFixed(1) + 'B';
  if (n >= 1e6) return '$' + (n / 1e6).toFixed(1) + 'M';
  if (n >= 1e3) return '$' + Math.round(n / 1e3) + 'K';
  return '$' + n;
};
const PLAN_KEYS = ['basico', 'pro', 'full'];
const planLabel = (p) => (PLAN_DEFS[p]?.nombre) || p || '—';
const EMPTY = { empresa_nombre:'', slug:'', nombre:'', email:'', password:'', plan:'basico' };

export default function SuperAdmin() {
  const [tenants, setTenants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState('');

  const cargar = () => { setLoading(true); superListTenants().then(r => setTenants(r.data)).catch(() => {}).finally(() => setLoading(false)); };
  useEffect(() => { cargar(); }, []);

  const toggle = async (t) => {
    if (t.activo) {
      const motivo = window.prompt(`Suspender "${t.nombre}". Motivo (se mostrará al intentar ingresar):`, 'Suspendida por falta de pago');
      if (motivo === null) return;
      await superToggleTenant(t.id, false, motivo);
    } else {
      if (!window.confirm(`¿Reactivar "${t.nombre}"?`)) return;
      await superToggleTenant(t.id, true);
    }
    cargar();
  };
  // Cambiar plan = aplicar el preset de módulos de ese plan (Nivel 2).
  const cambiarPlan = async (t, plan) => { await superSetModulos(t.id, { plan }); cargar(); };

  // Edición de módulos a medida.
  const [modMod, setModMod] = useState(null);   // tenant en edición
  const [modSel, setModSel] = useState([]);      // keys seleccionadas
  const abrirModulos = (t) => {
    const activos = Array.isArray(t.modulos_activos) ? t.modulos_activos : MODULOS.map(m => m.key); // null = todos
    setModSel(activos); setModMod(t);
  };
  const toggleMod = (k) => setModSel(s => s.includes(k) ? s.filter(x => x !== k) : [...s, k]);
  const guardarModulos = async () => {
    const sel = Array.from(new Set([...MODULOS_CORE, ...modSel])); // CORE siempre
    await superSetModulos(modMod.id, { modulos: sel });
    setModMod(null); cargar();
  };
  const renovar = async (t) => {
    const meses = window.prompt(`Renovar suscripción de "${t.nombre}".\n¿Cuántos meses? (suma desde el vencimiento actual; cierra el mes gratis y empieza a cobrar)`, '1');
    if (meses === null) return;
    const n = parseInt(meses, 10);
    if (!n || n < 1) return alert('Ingresa un número de meses válido');
    await superRenovarSuscripcion(t.id, { accion: 'renovar', meses: n }); cargar();
  };

  // ── Habilitación DIAN por empresa ──
  const [dianT, setDianT] = useState(null);
  const [dianTab, setDianTab] = useState('fe');
  const [dianForm, setDianForm] = useState(null);
  const [dianCert, setDianCert] = useState({ cargado: false });
  const [certFile, setCertFile] = useState(null);
  const [certPass, setCertPass] = useState('');
  const [dianMsg, setDianMsg] = useState(null);
  const [dianSaving, setDianSaving] = useState(false);
  const [enviandoPrueba, setEnviandoPrueba] = useState(false);
  const [pruebaMsg, setPruebaMsg] = useState(null);
  const [deposEstado, setDeposEstado] = useState(null);

  const enviarFacturaPrueba = async () => {
    setEnviandoPrueba('FV'); setPruebaMsg(null);
    try {
      const { data } = await superEnviarFacturaPrueba(dianT.id);
      const r = data.resultado;
      if (!r) {
        setPruebaMsg({ ok: false, text: `Factura ${data.numero} enviada (ZipKey ${data.zipKey || '—'}), pero no se pudo consultar el estado. Reintentá en unos segundos.` });
      } else if (r.isValid) {
        setPruebaMsg({ ok: true, text: `✅ Factura ${data.numero} ACEPTADA por la DIAN 🎉` });
      } else {
        const errs = (r.errorMessages || []).join(' · ') || r.statusMessage || 'Rechazada';
        setPruebaMsg({ ok: false, text: `Factura ${data.numero} → ❌ ${errs}` });
      }
    } catch (e) {
      const r = e.response?.data;
      const detalle = (r?.errores || r?.detalles || []);
      setPruebaMsg({ ok: false, text: '❌ ' + (r?.error || 'Error') + (detalle.length ? ' — ' + JSON.stringify(detalle).slice(0, 300) : '') });
    } finally { setEnviandoPrueba(false); }
  };

  const enviarSetCompleto = async () => {
    setEnviandoPrueba('LOTE'); setPruebaMsg(null);
    try {
      const { data } = await superEnviarSetCompleto(dianT.id);
      const r = data.resultado;
      const d = data.documentos || {};
      const desc = r ? (r.raw?.match(/<b:StatusDescription>([^<]*)/)?.[1] || '') : '';
      const setCerrado = /se encuentra Aceptado/i.test(desc); // set ya cerrado, NO valida el lote
      if (!r) {
        setPruebaMsg({ ok: false, text: `Lote enviado (FV ${d.FV}, NC ${d.NC}, ND ${d.ND}) ZipKey ${data.zipKey || '—'}, sin estado aún. Reintentá en unos segundos.` });
      } else if (r.isValid) {
        setPruebaMsg({ ok: true, text: `✅ Lote ACEPTADO — FV ${d.FV} · NC ${d.NC} · ND ${d.ND} 🎉 ${desc}` });
      } else if (setCerrado) {
        setPruebaMsg({ ok: false, text: `⚠️ El envío fue a un set YA CERRADO (${(desc.match(/identificador ([\w-]+)/) || [])[1] || '?'}). Actualizá el "ID del set de pruebas" al set nuevo + Software ID + PIN + clave técnica, y GUARDÁ antes de reenviar.` });
      } else {
        const errs = (r.errorMessages || []).join(' · ') || desc || 'Rechazado';
        setPruebaMsg({ ok: false, text: `Lote (FV ${d.FV} · NC ${d.NC} · ND ${d.ND}) → ❌ ${errs}` });
      }
    } catch (e) {
      const r = e.response?.data;
      const detalle = (r?.errores || r?.detalles || []);
      setPruebaMsg({ ok: false, text: '❌ ' + (r?.error || 'Error') + (detalle.length ? ' — ' + JSON.stringify(detalle).slice(0, 300) : '') });
    } finally { setEnviandoPrueba(false); }
  };

  const cargarDeposEstado = async (id) => {
    try { const { data } = await superDeposEstado(id || dianT.id); setDeposEstado(data); }
    catch (_) { setDeposEstado(null); }
  };

  const enviarDeposSet = async () => {
    setEnviandoPrueba('DEPOS'); setPruebaMsg(null);
    try {
      const { data } = await superEnviarDeposSet(dianT.id, { de: 10, nda: 5 });
      const r = data.resultado;
      const desc = r ? (r.raw?.match(/<b:StatusDescription>([^<]*)/)?.[1] || '') : '';
      const nDe = (data.de || []).length, nNda = (data.nda || []).length;
      if (!r) {
        setPruebaMsg({ ok: false, text: `Lote DE-POS enviado (${nDe} DE + ${nNda} Notas de Ajuste) ZipKey ${data.zipKey || '—'}, sin estado aún. Reintentá en unos segundos.` });
      } else if (r.isValid || /aceptad/i.test(desc)) {
        setPruebaMsg({ ok: true, text: `Lote DE-POS ACEPTADO — ${nDe} Documentos Equivalentes + ${nNda} Notas de Ajuste. ${desc}` });
      } else {
        const errs = (r.errorMessages || []).join(' · ') || desc || 'Rechazado';
        setPruebaMsg({ ok: false, text: `Lote DE-POS (${nDe} DE + ${nNda} NA) rechazado: ${errs}` });
      }
      cargarDeposEstado();
    } catch (e) {
      const r = e.response?.data;
      const detalle = (r?.errores || r?.detalles || []);
      setPruebaMsg({ ok: false, text: (r?.error || 'Error') + (detalle.length ? ' — ' + JSON.stringify(detalle).slice(0, 300) : '') });
    } finally { setEnviandoPrueba(false); }
  };

  const enviarNominaSet = async () => {
    setEnviandoPrueba('NOMINA'); setPruebaMsg(null);
    try {
      const { data } = await superEnviarNominaSet(dianT.id, 5);
      const r = data.resultado;
      const desc = r ? (r.raw?.match(/<b:StatusDescription>([^<]*)/)?.[1] || '') : '';
      const n = (data.documentos || []).length;
      if (!r) {
        setPruebaMsg({ ok: false, text: `Lote de nómina enviado (${n} docs) ZipKey ${data.zipKey || '—'}, sin estado aún. Reintentá.` });
      } else if (r.isValid || /aceptad/i.test(desc)) {
        setPruebaMsg({ ok: true, text: `✅ Lote de nómina ACEPTADO (${n} docs) 🎉 ${desc}` });
      } else {
        const errs = (r.errorMessages || []).join(' · ') || desc || 'Rechazado';
        setPruebaMsg({ ok: false, text: `Lote de nómina (${n} docs) → ❌ ${errs}` });
      }
    } catch (e) {
      const r = e.response?.data;
      const detalle = (r?.errores || r?.detalles || []);
      setPruebaMsg({ ok: false, text: '❌ ' + (r?.error || 'Error') + (detalle.length ? ' — ' + JSON.stringify(detalle).slice(0, 300) : '') });
    } finally { setEnviandoPrueba(false); }
  };

  const [sincDs, setSincDs] = useState(false);
  const sincronizarDs = async () => {
    setSincDs(true); setDianMsg(null);
    try {
      const { data } = await superSincronizarDs(dianT.id);
      const a = data.aplicada;
      setDianForm(f => ({ ...f,
        ds_resolucion_numero: a.resolucion_numero || '', ds_resolucion_prefijo: a.resolucion_prefijo || '',
        ds_resolucion_desde: a.resolucion_desde || '', ds_resolucion_hasta: a.resolucion_hasta || '',
        ds_fecha_desde: (a.resolucion_fecha_desde || '').slice(0, 10), ds_fecha_hasta: (a.resolucion_fecha_hasta || '').slice(0, 10) }));
      setDianMsg({ ok: true, text: `✅ Resolución DS sincronizada: ${a.resolucion_prefijo} ${a.resolucion_desde}–${a.resolucion_hasta}. Revisá y Guardá.` });
    } catch (e) {
      setDianMsg({ ok: false, text: '❌ ' + (e.response?.data?.error || 'No se pudo sincronizar') });
    } finally { setSincDs(false); }
  };

  const enviarNotaPrueba = async (tipo) => {
    setEnviandoPrueba(tipo); setPruebaMsg(null);
    const label = tipo === 'NC' ? 'Nota Crédito' : 'Nota Débito';
    try {
      const { data } = await superEnviarNotaPrueba(dianT.id, tipo);
      const r = data.resultado;
      if (!r) {
        setPruebaMsg({ ok: false, text: `${label} ${data.numero} enviada (ZipKey ${data.zipKey || '—'}), pero no se pudo consultar el estado. Reintentá en unos segundos.` });
      } else if (r.isValid) {
        setPruebaMsg({ ok: true, text: `✅ ${label} ${data.numero} (ref ${data.referencia}) ACEPTADA por la DIAN 🎉` });
      } else {
        const errs = (r.errorMessages || []).join(' · ') || r.statusMessage || 'Rechazada';
        setPruebaMsg({ ok: false, text: `${label} ${data.numero} → ❌ ${errs}` });
      }
    } catch (e) {
      const r = e.response?.data;
      const detalle = (r?.errores || r?.detalles || []);
      setPruebaMsg({ ok: false, text: '❌ ' + (r?.error || 'Error') + (detalle.length ? ' — ' + JSON.stringify(detalle).slice(0, 300) : '') });
    } finally { setEnviandoPrueba(false); }
  };

  const abrirDian = async (t) => {
    setDianT(t); setDianTab('fe'); setDianForm(null); setDianMsg(null); setCertFile(null); setCertPass('');
    try {
      const { data } = await superGetTenantDian(t.id);
      setDianForm({ software_id: data.software_id, software_pin: data.software_pin, fe_clave_tecnica: data.fe_clave_tecnica,
        fe_ambiente: data.fe_ambiente || '2', fe_nit_proveedor: data.fe_nit_proveedor, fe_nombre_proveedor: data.fe_nombre_proveedor,
        fe_test_set_id_actual: data.fe_test_set_id_actual,
        nomina_software_id: data.nomina_software_id, nomina_pin: data.nomina_pin, nomina_test_set_id: data.nomina_test_set_id,
        ds_resolucion_numero: data.ds_resolucion_numero, ds_resolucion_prefijo: data.ds_resolucion_prefijo,
        ds_resolucion_desde: data.ds_resolucion_desde, ds_resolucion_hasta: data.ds_resolucion_hasta,
        ds_fecha_desde: (data.ds_fecha_desde || '').slice(0, 10), ds_fecha_hasta: (data.ds_fecha_hasta || '').slice(0, 10),
        resolucion_prefijo: data.resolucion_prefijo, resolucion_numero: data.resolucion_numero,
        resolucion_desde: data.resolucion_desde, resolucion_hasta: data.resolucion_hasta,
        resolucion_fecha_desde: (data.resolucion_fecha_desde || '').slice(0, 10), resolucion_fecha_hasta: (data.resolucion_fecha_hasta || '').slice(0, 10),
        depos_software_id: data.depos_software_id || '', depos_software_pin: data.depos_software_pin || '',
        depos_resolucion: data.depos_resolucion || '', depos_prefijo: data.depos_prefijo || '',
        depos_rango_desde: data.depos_rango_desde || '', depos_rango_hasta: data.depos_rango_hasta || '',
        depos_fecha_desde: (data.depos_fecha_desde || '').slice(0, 10), depos_fecha_hasta: (data.depos_fecha_hasta || '').slice(0, 10),
        depos_test_set_id: data.depos_test_set_id || '', depos_ambiente: data.depos_ambiente || '2' });
      setPruebaMsg(null);
      setDianCert(data.cert || { cargado: false });
    } catch { setDianMsg({ ok: false, text: 'No se pudo cargar la config DIAN' }); }
  };
  const guardarDian = async () => {
    setDianSaving(true); setDianMsg(null);
    try {
      if (certFile) {
        if (!certPass) { setDianSaving(false); return setDianMsg({ ok: false, text: 'Falta la contraseña del certificado' }); }
        const fd = new FormData(); fd.append('cert', certFile); fd.append('password', certPass);
        const { data } = await superUploadTenantCert(dianT.id, fd);
        setDianCert({ cargado: true, meta: data.meta }); setCertFile(null); setCertPass('');
      }
      await superSetTenantDian(dianT.id, dianForm);
      setDianMsg({ ok: true, text: '✅ Habilitación DIAN guardada' });
    } catch (e) { setDianMsg({ ok: false, text: '❌ ' + (e.response?.data?.error || 'Error al guardar') }); }
    finally { setDianSaving(false); }
  };

  const crear = async (e) => {
    e.preventDefault();
    if (!form.empresa_nombre || !form.nombre || !form.email || !form.password) return setErr('Completá los campos obligatorios');
    setSaving(true); setErr('');
    try {
      await superCrearTenant(form);
      setModal(false); setForm(EMPTY); cargar();
    } catch (e2) { setErr(e2.response?.data?.error || 'Error al crear la empresa'); }
    finally { setSaving(false); }
  };

  const activas = tenants.filter(t => t.activo).length;
  const totalFacturado = tenants.reduce((s, t) => s + Number(t.facturado || 0), 0);

  return (
    <div>
      <div style={s.head}>
        <div>
          <h1 style={s.h1}>🛡️ Super Admin</h1>
          <p style={s.sub}>Administración de empresas de la plataforma</p>
        </div>
        <button style={s.btnPrimary} onClick={() => { setForm(EMPTY); setErr(''); setModal(true); }}>+ Nueva empresa</button>
      </div>

      <div style={s.kpis}>
        <Stat label="Empresas" value={tenants.length} color="#7dd3fc" />
        <Stat label="Activas" value={activas} color="#10b981" />
        <Stat label="Suspendidas" value={tenants.length - activas} color="#f59e0b" />
        <Stat label="Facturado (total)" value={fmtK(totalFacturado)} color="#a78bfa" />
      </div>

      <div style={s.card}>
        {loading ? <p style={s.hint}>Cargando…</p> : (
          <div style={{ overflowX:'auto' }}>
            <table style={s.table}>
              <thead><tr>{['Empresa','Plan','Suscripción','Usuarios','Clientes','Facturas','Facturado','Estado',''].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
              <tbody>
                {tenants.map(t => (
                  <tr key={t.id} style={s.tr}>
                    <td style={{ ...s.td, color:'#f1f5f9', fontWeight:500 }}>{t.nombre}<div style={{ color:'#475569', fontSize:11 }}>{t.slug}</div></td>
                    <td style={s.td}>
                      <select style={s.plan} value={PLAN_KEYS.includes(t.plan) ? t.plan : (t.modulos_activos ? 'personalizado' : 'full')} onChange={e => cambiarPlan(t, e.target.value)}>
                        {PLAN_KEYS.map(p => <option key={p} value={p}>{planLabel(p)}</option>)}
                        {!PLAN_KEYS.includes(t.plan) && <option value="personalizado" disabled>Personalizado</option>}
                      </select>
                    </td>
                    <td style={{ ...s.td, whiteSpace:'nowrap' }}>{(() => { const e = subEstado(t); return <span style={{ color: e.col, fontSize: 11.5 }}>{e.txt}</span>; })()}</td>
                    <td style={s.td}>{t.usuarios}</td>
                    <td style={s.td}>{t.clientes}</td>
                    <td style={s.td}>{t.facturas}</td>
                    <td style={{ ...s.td, color:'#10b981' }}>{fmtK(t.facturado)}</td>
                    <td style={s.td}>
                      {t.activo
                        ? <span style={{ ...s.badge, background:'#022c22', color:'#6ee7b7', border:'1px solid #10b981' }}>Activa</span>
                        : <span style={{ ...s.badge, background:'#450a0a', color:'#fca5a5', border:'1px solid #b91c1c' }} title={t.suspendido_motivo || ''}>Suspendida</span>}
                    </td>
                    <td style={s.td}>
                      <div style={{ display:'flex', gap:6, justifyContent:'flex-end' }}>
                        <button style={s.btnDian} onClick={() => abrirModulos(t)} title="Módulos contratados">⚙ Módulos</button>
                        <button style={s.btnDian} onClick={() => abrirDian(t)}>📄 DIAN</button>
                        <button style={s.btnActivar} onClick={() => renovar(t)} title="Renovar suscripción (meses)">💳 Renovar</button>
                        <button style={t.activo ? s.btnSuspend : s.btnActivar} onClick={() => toggle(t)}>
                          {t.activo ? 'Suspender' : 'Reactivar'}
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
                {tenants.length === 0 && <tr><td colSpan={9} style={{ ...s.td, textAlign:'center', padding:24, color:'#64748b' }}>Sin empresas.</td></tr>}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {modal && (
        <div style={s.overlay} onClick={() => !saving && setModal(false)}>
          <div style={s.modal} onClick={e => e.stopPropagation()}>
            <h2 style={s.modalTitle}>Nueva empresa</h2>
            {err && <div style={s.err}>{err}</div>}
            <form onSubmit={crear}>
              <Field label="Nombre de la empresa *" value={form.empresa_nombre} onChange={v => setForm({ ...form, empresa_nombre: v })} />
              <div style={s.row2}>
                <Field label="Slug (opcional)" value={form.slug} onChange={v => setForm({ ...form, slug: v })} placeholder="se genera del nombre" />
                <div style={s.field}>
                  <label style={s.label}>Plan</label>
                  <select style={s.plan} value={form.plan} onChange={e => setForm({ ...form, plan: e.target.value })}>
                    {PLAN_KEYS.map(p => <option key={p} value={p}>{planLabel(p)}</option>)}
                  </select>
                </div>
              </div>
              <div style={{ ...s.hint, marginBottom:12 }}>Usuario administrador de la empresa:</div>
              <Field label="Nombre del admin *" value={form.nombre} onChange={v => setForm({ ...form, nombre: v })} />
              <div style={s.row2}>
                <Field label="Email *" value={form.email} onChange={v => setForm({ ...form, email: v })} type="email" />
                <Field label="Contraseña *" value={form.password} onChange={v => setForm({ ...form, password: v })} type="password" />
              </div>
              <div style={{ display:'flex', justifyContent:'flex-end', gap:12, marginTop:8 }}>
                <button type="button" style={s.btnSec} onClick={() => setModal(false)} disabled={saving}>Cancelar</button>
                <button type="submit" style={s.btnPrimary} disabled={saving}>{saving ? 'Creando…' : 'Crear empresa'}</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {modMod && (
        <div style={s.overlay} onClick={() => setModMod(null)}>
          <div style={s.modal} onClick={e => e.stopPropagation()}>
            <h2 style={s.modalTitle}>⚙ Módulos — {modMod.nombre}</h2>
            <div style={{ ...s.hint, marginBottom:10 }}>Marca los módulos que la empresa tiene contratados. Los básicos (Dashboard, Configuración, Usuarios) van siempre.</div>
            <div style={{ display:'flex', gap:8, marginBottom:12 }}>
              {PLAN_KEYS.map(p => (
                <button key={p} type="button" style={{ ...s.btnSec, padding:'6px 10px', fontSize:12 }}
                  onClick={() => setModSel(Array.from(new Set([...MODULOS_CORE, ...PLAN_DEFS[p].modulos])))}>
                  Preset {planLabel(p)}
                </button>
              ))}
            </div>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8, maxHeight:320, overflowY:'auto' }}>
              {MODULOS.map(m => {
                const core = MODULOS_CORE.includes(m.key);
                const on = core || modSel.includes(m.key);
                return (
                  <label key={m.key} style={{ display:'flex', alignItems:'center', gap:8, padding:'8px 10px', background:'#0f172a', border:'1px solid #1e293b', borderRadius:8, opacity: core ? 0.6 : 1, cursor: core ? 'default' : 'pointer' }}>
                    <input type="checkbox" checked={on} disabled={core} onChange={() => toggleMod(m.key)} />
                    <span style={{ color:'#e2e8f0', fontSize:13 }}>{m.label}{core && <span style={{ color:'#64748b', fontSize:11 }}> · fijo</span>}</span>
                  </label>
                );
              })}
            </div>
            <div style={{ display:'flex', justifyContent:'flex-end', gap:12, marginTop:16 }}>
              <button type="button" style={s.btnSec} onClick={() => setModMod(null)}>Cancelar</button>
              <button type="button" style={s.btnPrimary} onClick={guardarModulos}>Guardar módulos</button>
            </div>
          </div>
        </div>
      )}

      {dianT && (
        <div style={s.overlay} onClick={() => !dianSaving && setDianT(null)}>
          <div style={s.modal} onClick={e => e.stopPropagation()}>
            <h2 style={s.modalTitle}>📄 Habilitación DIAN — {dianT.nombre}</h2>
            {!dianForm ? <p style={{ color:'#64748b' }}>Cargando…</p> : (
              <>
                <div style={{ color:'#94a3b8', fontSize:12, fontWeight:600, marginBottom:6 }}>Certificado digital (.p12)</div>
                <div style={{ background:'#0f172a', border:'1px solid #334155', borderRadius:8, padding:'10px 14px', marginBottom:12, fontSize:13 }}>
                  {dianCert.cargado
                    ? <span style={{ color:'#10b981' }}>✅ Certificado cargado{dianCert.meta?.vence ? ` · vence ${String(dianCert.meta.vence).slice(0, 10)}` : ''}</span>
                    : <span style={{ color:'#f59e0b' }}>⚠️ Sin certificado cargado</span>}
                </div>
                <div style={s.row2}>
                  <div style={s.field}><label style={s.label}>Archivo .p12 / .pfx</label>
                    <input type="file" accept=".p12,.pfx" style={{ ...s.input, padding:'7px 10px' }} onChange={e => setCertFile(e.target.files[0] || null)} /></div>
                  <div style={s.field}><label style={s.label}>Contraseña del .p12</label>
                    <input type="password" style={s.input} value={certPass} onChange={e => setCertPass(e.target.value)} placeholder="••••••••" autoComplete="new-password" /></div>
                </div>

                <div style={{ display:'flex', gap:4, borderBottom:'1px solid #334155', margin:'14px 0 12px' }}>
                  {[['fe','🧾 Factura Electrónica'],['depos','Documento Equivalente POS'],['nomina','👥 Nómina Electrónica'],['ds','📑 Documento Soporte']].map(([k, lbl]) => (
                    <button key={k} type="button" onClick={() => { setDianTab(k); if (k === 'depos') cargarDeposEstado(); }}
                      style={{ background:'none', border:'none', cursor:'pointer', padding:'8px 14px', fontSize:13, fontWeight:600,
                        color: dianTab === k ? '#3b82f6' : '#94a3b8',
                        borderBottom: dianTab === k ? '2px solid #3b82f6' : '2px solid transparent', marginBottom:-1 }}>
                      {lbl}
                    </button>
                  ))}
                </div>

                {dianTab === 'fe' && <>
                  <div style={{ color:'#94a3b8', fontSize:12, fontWeight:600, margin:'6px 0' }}>Software DIAN</div>
                  <div style={s.row2}>
                    <Field label="ID del software" value={dianForm.software_id} onChange={v => setDianForm({ ...dianForm, software_id: v })} />
                    <Field label="PIN del software" value={dianForm.software_pin} onChange={v => setDianForm({ ...dianForm, software_pin: v })} />
                  </div>
                  <Field label="Clave técnica (40 caracteres)" value={dianForm.fe_clave_tecnica} onChange={v => setDianForm({ ...dianForm, fe_clave_tecnica: v })} />
                  <div style={s.row2}>
                    <div style={s.field}><label style={s.label}>Ambiente</label>
                      <select style={s.input} value={dianForm.fe_ambiente} onChange={e => setDianForm({ ...dianForm, fe_ambiente: e.target.value })}>
                        <option value="2">Pruebas (2)</option><option value="1">Producción (1)</option>
                      </select></div>
                    <Field label="NIT proveedor (opcional)" value={dianForm.fe_nit_proveedor} onChange={v => setDianForm({ ...dianForm, fe_nit_proveedor: v })} />
                  </div>

                  <div style={{ color:'#94a3b8', fontSize:12, fontWeight:600, margin:'6px 0' }}>Set de pruebas (habilitación)</div>
                  <Field label="ID del set de pruebas (DIAN)" value={dianForm.fe_test_set_id_actual} onChange={v => setDianForm({ ...dianForm, fe_test_set_id_actual: v })} />
                  <p style={{ color:'#64748b', fontSize:12, margin:'-6px 0 8px' }}>El ID te lo da la DIAN en el portal de Habilitación.</p>
                  <div style={s.row2}>
                    <Field label="Prefijo resolución (pruebas: SETP)" value={dianForm.resolucion_prefijo} onChange={v => setDianForm({ ...dianForm, resolucion_prefijo: v })} />
                    <Field label="Número resolución" value={dianForm.resolucion_numero} onChange={v => setDianForm({ ...dianForm, resolucion_numero: v })} />
                  </div>
                  <div style={s.row2}>
                    <Field label="Rango desde" value={dianForm.resolucion_desde} onChange={v => setDianForm({ ...dianForm, resolucion_desde: v })} />
                    <Field label="Rango hasta" value={dianForm.resolucion_hasta} onChange={v => setDianForm({ ...dianForm, resolucion_hasta: v })} />
                  </div>
                  <div style={s.row2}>
                    <Field label="Vigencia desde" value={dianForm.resolucion_fecha_desde} onChange={v => setDianForm({ ...dianForm, resolucion_fecha_desde: v })} type="date" />
                    <Field label="Vigencia hasta" value={dianForm.resolucion_fecha_hasta} onChange={v => setDianForm({ ...dianForm, resolucion_fecha_hasta: v })} type="date" />
                  </div>

                  <div style={{ background:'#0f172a', border:'1px solid #3b82f6', borderRadius:8, padding:12, marginTop:8 }}>
                    <div style={{ color:'#94a3b8', fontSize:12, marginBottom:8 }}>Completá el set de pruebas para habilitar el software. <b>Guardá primero</b> los datos de arriba. El set se cierra apenas se acepta 1 factura, así que para validar NC/ND hay que mandar <b>todo en un solo lote</b>.</div>
                    <button type="button" style={{ ...s.btnDian, padding:'10px 16px', fontWeight:700, width:'100%', marginBottom:8 }} onClick={enviarSetCompleto} disabled={!!enviandoPrueba}>
                      {enviandoPrueba === 'LOTE' ? 'Enviando lote a la DIAN…' : '📦 Enviar SET COMPLETO (FV + NC + ND en un lote)'}
                    </button>
                    <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
                      <button type="button" style={{ ...s.btnDian, padding:'8px 14px' }} onClick={enviarFacturaPrueba} disabled={!!enviandoPrueba}>
                        {enviandoPrueba === 'FV' ? 'Enviando…' : '🧪 Solo Factura'}
                      </button>
                      <button type="button" style={{ ...s.btnDian, padding:'8px 14px' }} onClick={() => enviarNotaPrueba('NC')} disabled={!!enviandoPrueba}>
                        {enviandoPrueba === 'NC' ? 'Enviando…' : '🧾 Solo NC'}
                      </button>
                      <button type="button" style={{ ...s.btnDian, padding:'8px 14px' }} onClick={() => enviarNotaPrueba('ND')} disabled={!!enviandoPrueba}>
                        {enviandoPrueba === 'ND' ? 'Enviando…' : '🧾 Solo ND'}
                      </button>
                    </div>
                    {pruebaMsg && <p style={{ color: pruebaMsg.ok ? '#10b981' : '#f87171', fontSize:13, marginTop:8, wordBreak:'break-word' }}>{pruebaMsg.text}</p>}
                  </div>
                </>}

                {dianTab === 'nomina' && <>
                  <div style={{ color:'#94a3b8', fontSize:12, fontWeight:600, margin:'6px 0' }}>Software de nómina (el portal DIAN lo da aparte del de factura)</div>
                  <div style={s.row2}>
                    <Field label="Software ID nómina" value={dianForm.nomina_software_id} onChange={v => setDianForm({ ...dianForm, nomina_software_id: v })} />
                    <Field label="PIN nómina" value={dianForm.nomina_pin} onChange={v => setDianForm({ ...dianForm, nomina_pin: v })} />
                  </div>
                  <Field label="ID del set de pruebas de nómina (DIAN)" value={dianForm.nomina_test_set_id} onChange={v => setDianForm({ ...dianForm, nomina_test_set_id: v })} />
                  <div style={{ background:'#0f172a', border:'1px solid #3b82f6', borderRadius:8, padding:12, marginTop:8 }}>
                    <div style={{ color:'#94a3b8', fontSize:12, marginBottom:8 }}>Nómina Electrónica — <b>Guardá primero</b>, luego envía 5 Nóminas + 5 Notas de Ajuste al set de nómina (mín. 4+4 para habilitar).</div>
                    <button type="button" style={{ ...s.btnDian, padding:'10px 16px', fontWeight:700, width:'100%' }} onClick={enviarNominaSet} disabled={!!enviandoPrueba}>
                      {enviandoPrueba === 'NOMINA' ? 'Enviando nómina a la DIAN…' : '👥 Enviar SET NÓMINA (5 Nóminas + 5 Ajustes)'}
                    </button>
                    {pruebaMsg && <p style={{ color: pruebaMsg.ok ? '#10b981' : '#f87171', fontSize:13, marginTop:8, wordBreak:'break-word' }}>{pruebaMsg.text}</p>}
                  </div>
                </>}

                {dianTab === 'depos' && <>
                  <div style={{ background:'#0f172a', border:'1px solid #334155', borderRadius:8, padding:'10px 14px', marginBottom:12, fontSize:12.5, color:'#94a3b8' }}>
                    Documento Equivalente POS (tipo 20) — usa un <b>software y resolución propios</b> (bloque DE-POS), distintos a la factura tipo 01. Se firma con el <b>mismo certificado</b> del tenant y se envía a <b>habilitación (ambiente 2)</b>, sin tocar la factura de producción. Cada empresa carga su propio bloque DE-POS aquí.
                  </div>

                  <div style={{ color:'#94a3b8', fontSize:12, fontWeight:600, margin:'6px 0' }}>Software DE-POS (el portal DIAN lo da aparte del de factura)</div>
                  <div style={s.row2}>
                    <Field label="Software ID DE-POS" value={dianForm.depos_software_id} onChange={v => setDianForm({ ...dianForm, depos_software_id: v })} />
                    <Field label="PIN DE-POS" value={dianForm.depos_software_pin} onChange={v => setDianForm({ ...dianForm, depos_software_pin: v })} />
                  </div>
                  <Field label="ID del set de pruebas DE-POS (DIAN)" value={dianForm.depos_test_set_id} onChange={v => setDianForm({ ...dianForm, depos_test_set_id: v })} />

                  <div style={{ color:'#94a3b8', fontSize:12, fontWeight:600, margin:'10px 0 6px' }}>Resolución de numeración DE-POS</div>
                  <div style={s.row2}>
                    <Field label="Prefijo (ej. EPOS)" value={dianForm.depos_prefijo} onChange={v => setDianForm({ ...dianForm, depos_prefijo: v })} />
                    <Field label="Número de resolución" value={dianForm.depos_resolucion} onChange={v => setDianForm({ ...dianForm, depos_resolucion: v })} />
                  </div>
                  <div style={s.row2}>
                    <Field label="Rango desde" value={dianForm.depos_rango_desde} onChange={v => setDianForm({ ...dianForm, depos_rango_desde: v })} />
                    <Field label="Rango hasta" value={dianForm.depos_rango_hasta} onChange={v => setDianForm({ ...dianForm, depos_rango_hasta: v })} />
                  </div>
                  <div style={s.row2}>
                    <Field label="Vigencia desde" value={dianForm.depos_fecha_desde} onChange={v => setDianForm({ ...dianForm, depos_fecha_desde: v })} type="date" />
                    <Field label="Vigencia hasta" value={dianForm.depos_fecha_hasta} onChange={v => setDianForm({ ...dianForm, depos_fecha_hasta: v })} type="date" />
                  </div>
                  <button type="button" style={{ ...s.btnDian, padding:'8px 14px', marginTop:4 }} onClick={guardarDian} disabled={dianSaving}>
                    {dianSaving ? 'Guardando…' : 'Guardar bloque DE-POS'}
                  </button>
                  {deposEstado && (
                    <div style={s.row2}>
                      <div style={{ background:'#0f172a', border:'1px solid #334155', borderRadius:8, padding:'8px 12px', fontSize:12.5, color:'#cbd5e1' }}>
                        Documentos Equivalentes: <b>{deposEstado.de?.enviados || 0}</b> enviados · <b style={{ color:'#10b981' }}>{deposEstado.de?.aceptados || 0}</b> aceptados <span style={{ color:'#64748b' }}>(requeridos {deposEstado.requeridos?.de}, aceptar {deposEstado.requeridos?.de_aceptados})</span>
                      </div>
                      <div style={{ background:'#0f172a', border:'1px solid #334155', borderRadius:8, padding:'8px 12px', fontSize:12.5, color:'#cbd5e1' }}>
                        Notas de Ajuste: <b>{deposEstado.nda?.enviados || 0}</b> enviadas · <b style={{ color:'#10b981' }}>{deposEstado.nda?.aceptados || 0}</b> aceptadas <span style={{ color:'#64748b' }}>(requeridas {deposEstado.requeridos?.nda})</span>
                      </div>
                    </div>
                  )}
                  <div style={{ background:'#0f172a', border:'1px solid #3b82f6', borderRadius:8, padding:12, marginTop:8 }}>
                    <div style={{ color:'#94a3b8', fontSize:12, marginBottom:8 }}>El set DE-POS se valida en <b>un solo lote</b> (10 Documentos Equivalentes + 5 Notas de Ajuste): el set se cierra apenas se acepta 1 documento, así que las Notas de Ajuste deben ir junto a los DE que referencian. Requiere el certificado cargado y el bloque DE-POS configurado en la base.</div>
                    <button type="button" style={{ ...s.btnDian, padding:'10px 16px', fontWeight:700, width:'100%', marginBottom:8 }} onClick={enviarDeposSet} disabled={!!enviandoPrueba}>
                      {enviandoPrueba === 'DEPOS' ? 'Enviando lote a la DIAN…' : 'Enviar SET DE-POS (10 Documentos Equivalentes + 5 Notas de Ajuste)'}
                    </button>
                    <button type="button" style={{ ...s.btnDian, padding:'7px 12px', fontSize:12 }} onClick={() => cargarDeposEstado()} disabled={!!enviandoPrueba}>
                      Actualizar estado
                    </button>
                    {pruebaMsg && <p style={{ color: pruebaMsg.ok ? '#10b981' : '#f87171', fontSize:13, marginTop:8, wordBreak:'break-word' }}>{pruebaMsg.text}</p>}
                  </div>
                  {deposEstado?.documentos?.length > 0 && (
                    <div style={{ marginTop:12, maxHeight:260, overflowY:'auto', border:'1px solid #334155', borderRadius:8 }}>
                      <table style={{ width:'100%', borderCollapse:'collapse', fontSize:12 }}>
                        <thead><tr style={{ color:'#94a3b8', textAlign:'left' }}>
                          <th style={{ padding:'6px 10px' }}>Número</th><th style={{ padding:'6px 10px' }}>Tipo</th><th style={{ padding:'6px 10px' }}>Estado DIAN</th>
                        </tr></thead>
                        <tbody>
                          {deposEstado.documentos.map(d => {
                            const acc = ['0','00'].includes(String(d.dian_status_code)) || d.estado_fe === 'aceptada';
                            return (
                              <tr key={d.id} style={{ borderTop:'1px solid #1e293b' }}>
                                <td style={{ padding:'6px 10px', color:'#e2e8f0' }}>{d.numero}</td>
                                <td style={{ padding:'6px 10px', color:'#94a3b8' }}>{d.tipo_documento_fe === '20' ? 'DE-POS' : 'Nota de Ajuste'}</td>
                                <td style={{ padding:'6px 10px', color: acc ? '#10b981' : '#f59e0b' }}>{acc ? 'Aceptado' : (d.dian_status_msg || d.estado_fe || 'pendiente')}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  )}
                </>}

                {dianTab === 'ds' && (<>
                  <div style={{ background:'#0f172a', border:'1px solid #334155', borderRadius:8, padding:'10px 14px', marginBottom:12, fontSize:12.5, color:'#94a3b8' }}>
                    ✅ El Documento Soporte usa el <b>mismo software y certificado de FE</b> (software propio ya habilitado). No requiere set de pruebas. Solo cargá la <b>resolución de numeración de DS</b>.
                  </div>
                  <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', margin:'6px 0' }}>
                    <span style={{ color:'#94a3b8', fontSize:12, fontWeight:600 }}>Resolución de numeración — Documento Soporte</span>
                    <button type="button" style={{ ...s.btnDian, padding:'6px 12px', fontSize:12 }} onClick={sincronizarDs} disabled={sincDs}>
                      {sincDs ? 'Sincronizando…' : '🔄 Sincronizar con la DIAN'}
                    </button>
                  </div>
                  <div style={s.row2}>
                    <Field label="Prefijo (ej: DS)" value={dianForm.ds_resolucion_prefijo} onChange={v => setDianForm({ ...dianForm, ds_resolucion_prefijo: v })} />
                    <Field label="Número de autorización" value={dianForm.ds_resolucion_numero} onChange={v => setDianForm({ ...dianForm, ds_resolucion_numero: v })} />
                  </div>
                  <div style={s.row2}>
                    <Field label="Rango desde" value={dianForm.ds_resolucion_desde} onChange={v => setDianForm({ ...dianForm, ds_resolucion_desde: v })} />
                    <Field label="Rango hasta" value={dianForm.ds_resolucion_hasta} onChange={v => setDianForm({ ...dianForm, ds_resolucion_hasta: v })} />
                  </div>
                  <div style={s.row2}>
                    <Field label="Vigencia desde" value={dianForm.ds_fecha_desde} onChange={v => setDianForm({ ...dianForm, ds_fecha_desde: v })} type="date" />
                    <Field label="Vigencia hasta" value={dianForm.ds_fecha_hasta} onChange={v => setDianForm({ ...dianForm, ds_fecha_hasta: v })} type="date" />
                  </div>
                  <div style={{ color:'#64748b', fontSize:12, marginTop:6 }}>Luego el DS se emite desde una orden de compra a un proveedor marcado como "no obligado a facturar".</div>
                </>)}

                {dianMsg && <p style={{ color: dianMsg.ok ? '#10b981' : '#f87171', fontSize:13 }}>{dianMsg.text}</p>}
                <div style={{ display:'flex', justifyContent:'flex-end', gap:12, marginTop:8 }}>
                  <button type="button" style={s.btnSec} onClick={() => setDianT(null)} disabled={dianSaving}>Cerrar</button>
                  <button type="button" style={s.btnPrimary} onClick={guardarDian} disabled={dianSaving}>{dianSaving ? 'Guardando…' : 'Guardar habilitación'}</button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

const Stat = ({ label, value, color }) => (
  <div style={s.statBox}><div style={{ fontSize:24, fontWeight:700, color }}>{value}</div><div style={{ fontSize:12, color:'#64748b' }}>{label}</div></div>
);
const Field = ({ label, value, onChange, type = 'text', placeholder }) => (
  <div style={s.field}><label style={s.label}>{label}</label>
    <input style={s.input} type={type} value={value} placeholder={placeholder} onChange={e => onChange(e.target.value)} /></div>
);

const s = {
  head: { display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:16 },
  h1: { fontSize:24, fontWeight:700, color:'#f1f5f9', margin:'0 0 2px' },
  sub: { color:'#64748b', fontSize:14, margin:0 },
  kpis: { display:'flex', gap:14, marginBottom:16, flexWrap:'wrap' },
  statBox: { background:'#1e293b', border:'1px solid #334155', borderRadius:12, padding:'14px 20px', textAlign:'center', minWidth:120, flex:1 },
  card: { background:'#1e293b', border:'1px solid #334155', borderRadius:12, padding:16 },
  table: { width:'100%', borderCollapse:'collapse', fontSize:13 },
  th: { color:'#64748b', fontSize:11, fontWeight:600, textAlign:'left', padding:'0 10px 10px', textTransform:'uppercase' },
  tr: { borderTop:'1px solid #334155' },
  td: { padding:'8px 10px', color:'#94a3b8' },
  badge: { borderRadius:6, padding:'2px 8px', fontSize:11 },
  plan: { background:'#0f172a', border:'1px solid #334155', color:'#f1f5f9', borderRadius:6, padding:'3px 8px', fontSize:12, cursor:'pointer' },
  btnDian: { background:'#1e3a5f', border:'1px solid #3b82f6', color:'#7dd3fc', borderRadius:6, padding:'4px 12px', fontSize:12, cursor:'pointer' },
  btnSuspend: { background:'#450a0a', border:'1px solid #b91c1c', color:'#fca5a5', borderRadius:6, padding:'4px 12px', fontSize:12, cursor:'pointer' },
  btnActivar: { background:'#022c22', border:'1px solid #10b981', color:'#6ee7b7', borderRadius:6, padding:'4px 12px', fontSize:12, cursor:'pointer' },
  btnPrimary: { background:'#3b82f6', color:'#fff', border:'none', borderRadius:10, padding:'10px 18px', fontSize:14, fontWeight:600, cursor:'pointer' },
  btnSec: { background:'#334155', color:'#cbd5e1', border:'none', borderRadius:8, padding:'10px 18px', fontSize:14, cursor:'pointer' },
  hint: { color:'#64748b', fontSize:13 },
  overlay: { position:'fixed', inset:0, background:'rgba(0,0,0,0.6)', display:'flex', alignItems:'center', justifyContent:'center', padding:20, zIndex:50 },
  modal: { background:'#1e293b', borderRadius:12, border:'1px solid #334155', padding: 18, width:'100%', maxWidth:560, maxHeight:'90vh', overflowY:'auto' },
  modalTitle: { color:'#f1f5f9', fontSize:16, fontWeight:700, margin:'0 0 12px' },
  err: { background:'#450a0a', border:'1px solid #b91c1c', borderRadius:8, color:'#fca5a5', padding:'10px 14px', marginBottom:14, fontSize:13 },
  row2: { display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 },
  field: { marginBottom:14 },
  label: { display:'block', color:'#94a3b8', fontSize:12, marginBottom:4, fontWeight:500 },
  input: { width:'100%', height:34, padding:'0 12px', background:'#0f172a', border:'1px solid #334155', borderRadius:8, color:'#f1f5f9', fontSize:13, outline:'none', boxSizing:'border-box' },
};
